import { exchangeCatalogCode } from './exchangeCatalogCode'
import { normalizeLoginResponse } from './normalizeLoginResponse'
import { processAuthSession } from './processAuthSession'

/** Consume ?code= from Catalog handoff. Returns error message or null. */
export async function acceptCatalogHandoffCode(code) {
  const data = await exchangeCatalogCode(code)
  return processAuthSession(normalizeLoginResponse(data), { loginType: 'catalog' })
}
